module.exports = __webpack_public_path__ + "img/16.46bf30ae.jpg";